import { useQueryClient } from '@tanstack/react-query';

import { beDeleteFee } from 'actions/taxes/beDeleteFee.action';
import { beDeleteTax } from 'actions/taxes/beDeleteTax.action';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { usePrepareWriteOnly } from 'hooks/usePrepare.hook';
import useTip from 'hooks/useTip.hook';

import { DeleteRuleModal } from './DeleteRuleModal';

export const DeleteRuleButton = ({ rule, variant }) => {
  const { val: isDeleteRuleModalOpen, yay: showDeleteRuleModal, nay: hideDeleteRuleModal } = useTip(false);

  const { data: deleteTaxData, up: deleteTaxMutation, isLoading: isDeletingTax, isError: isDeletingTaxError } = usePrepareWriteOnly(beDeleteTax);
  const { data: deleteFeeData, up: deleteFeeMutation, isLoading: isDeletingFee, isError: isDeletingFeeError } = usePrepareWriteOnly(beDeleteFee);
  const queryClient = useQueryClient();

  const hasTaxError = deleteTaxData?.json?.errors || deleteTaxData?.is?.ok === false || isDeletingTaxError;
  const hasFeeError = deleteFeeData?.json?.errors || deleteFeeData?.is?.ok === false || isDeletingFeeError;
  const hasError = hasTaxError || hasFeeError;

  const deleteRule = async () => {
    if (isDeletingTax || isDeletingFee) return;

    const isTax = variant === 'tax';

    if (isTax) {
      const response = await deleteTaxMutation({ id: rule.id });
      if (response?.is?.ok) {
        queryClient.invalidateQueries({ queryKey: ['beGetSalonTaxesAndFees'] });
        hideDeleteRuleModal();
      }
    } else {
      const response = await deleteFeeMutation({ id: rule.id });
      if (response?.is?.ok) {
        queryClient.invalidateQueries({ queryKey: ['beGetSalonTaxesAndFees'] });
        hideDeleteRuleModal();
      }
    }
  };

  return (
    <>
      <Button variant="bin" onClick={showDeleteRuleModal} tag="RuleCard__deleteRuleButton">
        <Icon variant="delete" width="lg" />
      </Button>

      <DeleteRuleModal isOpen={isDeleteRuleModalOpen} onClose={hideDeleteRuleModal} onConfirm={deleteRule} isDisabled={isDeletingTax || isDeletingFee} hasError={hasError} />
    </>
  );
};
